import Ajax from '../js/common/ajax';

export default {
  readExcelData(formData) {
    return Ajax.post('/accounting/reference-facts/excel-data', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  queryByImportBatchId(importBatchId, params = {}) {
    return Ajax.get(`/accounting/reference-facts/import-batches/${encodeURIComponent(importBatchId)}`, params);
  },

  listImportBatches(params = {}) {
    return Ajax.get('/accounting/reference-facts/import-batches', params);
  },

  queryReferenceFacts(params = {}) {
    return Ajax.get('/accounting/reference-facts', params);
  },

  updateFact(id, data) {
    return Ajax.patchJson(`/accounting/reference-facts/${id}`, data);
  },

  archiveFact(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/archive`, data);
  },

  archiveBatch(importBatchId, data) {
    return Ajax.post(`/accounting/reference-facts/import-batches/${encodeURIComponent(importBatchId)}/archive`, data);
  },

  rematchBizrel(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/rematch-bizrel`, data);
  },

  // Lifecycle governance
  ignoreFact(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/ignore`, data);
  },

  restoreFact(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/restore`, data);
  },

  supersedeFact(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/supersede`, data);
  },

  // BizRel resolution governance
  resolveBizrel(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/resolve-bizrel`, data);
  },

  clearBizrelResolution(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/clear-bizrel-resolution`, data);
  },

  ignoreBizrelResolution(id, data) {
    return Ajax.post(`/accounting/reference-facts/${id}/ignore-bizrel-resolution`, data);
  },

  // Batch governance
  ignoreBatch(importBatchId, data) {
    return Ajax.post(`/accounting/reference-facts/import-batches/${encodeURIComponent(importBatchId)}/ignore`, data);
  },

  rematchBizrelBatch(importBatchId, data) {
    return Ajax.post(`/accounting/reference-facts/import-batches/${encodeURIComponent(importBatchId)}/rematch-bizrel`, data);
  },

  // 通用导入端点（C3 新增，C4 删除旧专用方法后唯一路径）
  importByFactType(data) {
    return Ajax.postJson('/accounting/reference-facts/import', data);
  },

  importExcelByFactType(formData) {
    return Ajax.post('/accounting/reference-facts/import-excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};
